import { List as ImmutableList } from 'immutable';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { fetchChannelInstances as requestFn } from '../clients/fetchChannelInstances';
import { FETCH_CHANNEL_INSTANCES as actionTypes } from '../constants/asyncActionTypes';
export const fetchChannelInstances = createAsyncAction({
  requestFn,
  actionTypes,
  toRecordFn: ImmutableList
});